class CustomFeaturedTabs extends HTMLElement {
  constructor() {
    console.log('CustomFeaturedTabs constructor');
    super();
    this.tabsContainer = this.querySelector('[data-tabs-container]');
    this.tabs = this.querySelectorAll('.custom-featured-tabs__tab');
    this.tabContents = this.querySelectorAll('.custom-featured-tabs__tab-content');
    this.swipers = [];

    if (!this.tabsContainer) return;

    this.init();
  }

  init() {
    // Initialize tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.setActiveTab(index);
      });
    });

    // Initialize swipers after they're mounted
    window.addEventListener('load', () => {
      this.initSwipers();
    });

    // Handle tab indicator position on resize
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  setActiveTab(index) {
    // Update tab states
    this.tabs.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
      } else {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      }
    });

    // Update content states
    this.tabContents.forEach((content, i) => {
      if (i === index) {
        content.classList.add('is-active');
      } else {
        content.classList.remove('is-active');
      }
    });

    // Update swiper for the active tab
    if (this.swipers[index]) {
      this.swipers[index].update();
    }
  }

  initSwipers() {
    this.tabContents.forEach((content, index) => {
      const swiperElement = content.querySelector('swiper-slider');

      if (swiperElement) {
        // Store reference to swiper instance
        swiperElement.addEventListener('swiper-init', (event) => {
          this.swipers[index] = event.detail[0];
        });
      }
    });
  }

  handleResize() {
    // Update all swipers on resize
    this.swipers.forEach((swiper) => {
      if (swiper) {
        swiper.update();
      }
    });
  }
}

customElements.define('custom-featured-tabs', CustomFeaturedTabs);
